function setFavoritesTabsPosition(direction){
    const tabs = $('.js-favorites-tabs-container');
    if(direction == 'down'){
        tabs.removeClass('up');
    }
    if(direction == 'up'){
        tabs.addClass('up');
    }
}
